<template>
<v-row justify="center" class="border-radius-3">
    <v-dialog
        content-class="border-radius-3"
        v-model="dialog"
        persistent
        width="850"
        :retain-focus="false"
        overlay-color="primary"
        overlay-opacity="0.75"
    >    
        <v-card class="border-radius-3 pa-5">
            <v-card-title class=" d-flex justify-center">
                <span
                    class="titles text-h6 font-weight-medium primary--text py-3 d-flex justify-center"
                    >
                    {{ $t('initialTour.categories_select') }}
                </span>
            </v-card-title>
            <v-container class=" height-viewport-100">
                <div class="d-flex justify-content category-content">
                    <v-row class="pa-0 ma-0 main-categories">
                        <v-col
                            cols="2"
                            v-for="(category, index) of categories"
                            :key="index"
                            class="pa-0 ma-2"
                        >
                            <Category :data="category" :selected="isCategorySelected(category)" :key="reload"></Category>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
            <v-card-actions class="d-flex justify-center">
                <v-btn
                    color="secondary"
                    class="no-uppercase mx-2"
                    width="180"
                    large
                    rounded
                    outlined
                    @click="closeModal"
                    :disabled="btnLoading"
                >
                    {{ $t('profile.leave') }}
                </v-btn>
                <v-btn
                    color="secondary"
                    class="no-uppercase mx-2"
                    width="180"
                    large
                    rounded
                    @click="updateCategories"
                    :loading="btnLoading"
                >
                    {{ $t('profile.save_changes') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </v-row>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import UserService from '@/services/users'
import Category from '../onBoarding/CategoriesCore/Category.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components:{
        Category,
    },
    data() {
        return {
            btnLoading: false,
            reload: 0,
            select_categories: [],
            selectedCategoriesObj: []
        }
    },
    computed: {
        ...mapState(['categories']),
        ...mapState({
            stCategories: (state) => state.userData.selectedCategories,
            stUserAvatar: (state) => state.userData.avatarSelected,
            stUser: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
        username() {
            return `${this.user.firstname.split(' ')[0]} ${this.user.lastname.split(' ')[0]}`
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'showCategories',
            'showAvatars',
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
        ]),
        ...mapActions('userData', ['changeCategories']),
        closeModal () {
            this.$emit('close')
            this.reload += 1
        },
        isCategorySelected(category) {
            const exists = this.stCategories.find(categorySelected => category.id === categorySelected.id)
            return typeof exists !== 'undefined'
        },
        searchCategorySelected(categoryId) {
            return this.categories.find(categorySelected => Number(categoryId) === Number(categorySelected.id))
        },
        async updateCategories() {
            const vm = this
            vm.select_categories = []
            vm.selectedCategoriesObj = []
            document.querySelectorAll('.category-active').forEach((obj) => {
                const id = obj.getAttribute('data-category-id')
                const category = this.searchCategorySelected(id)
                vm.select_categories.push(id)
                vm.selectedCategoriesObj.push(category)
            })

            this.changeCategories(this.selectedCategoriesObj)

            this.btnLoading = true
            await this.updateUserPreferences({
                userId: this.stUser.id,
                avatar: this.stUserAvatar.id,
                userAvatar: this.stUserAvatar.id,
                categories: this.select_categories,
            })
            this.btnLoading = false
        },
        updateUserPreferences(data) {
            return new Promise((resolve, reject) => {
                UserService.updateUserPreferences(data)
                    .then((response) => {
                        resolve(response)
                        this.closeModal()
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
            })
        }
    }
}
</script>

<style>
.color-primary {
    color: #514773;
}
.color-name {
    color: #4A3216;
}
.no-uppercase {
     text-transform: none;
}

.category-content {
    height: 50vh;
    overflow: auto;
}

.main-categories {
    justify-content: center;
    align-items: self-start;
    align-content: start;
}

.category-img {
    display: block;
    max-width: 52vh;
    height: 5vh;
}

.sm-category-img {
    display: block;
    max-width: 52vh;
    height: 4vh;
}

.category-active .category-box {
    border: 1vh solid #4caf50;
}

.category-check {
    display: none;
}
.category-active .category-check {
    bottom: -12px;
    right: 0px;
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
}

.category-active .sm-category-img {
    height: 5vh;
}
</style>